export const options = {
    method: 'GET',
    headers: {
        accept: 'application/json',
        Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjZDI0Y2I5MDlkYTNjNjU2MGJiNzZmNTA5Yzc4ODQ3NSIsInN1YiI6IjY2MzJmZjllODEzY2I2MDEyNzg2YzQ4YSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.Bu0BdsQl6Sjm7gTyGOuuqET6QBLluwZtc1_QuOb8SNc', // Replace YOUR_API_TOKEN_HERE with your actual API token
    },
};

export const IMG_CDN_URL = "https://image.tmdb.org/t/p/w500"

export const SUPPORTED_CONST = [
    {identifier: "en", language: "English"},
    {identifier: "hindi", language: "Hindi"},
    {identifier: "guj", language: "Gujarati"}]

export const OPEN_AI_GPT_KEY = "sk-proj-GZXq8yi5qKe3chvtDUGcT3BlbkFJzxTnzr52P5z3trfNgic8"